//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  name: 'KijkGratis',
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages,
    }),
  },
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'info-kijk-gratis')
      ])
  },
  head() {
    return {
      title: this.pages.infokijkgratis ? this.pages.infokijkgratis.seo.title : 'Kijk Gratis | Info | Secret Circle',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.infokijkgratis ? this.pages.infokijkgratis.seo.title : 'Kijk Gratis | Info | Secret Circle' },
        { hid: 'og:title', name: 'og:title', content: this.pages.infokijkgratis ? this.pages.infokijkgratis.seo.title : 'Kijk Gratis | Info | Secret Circle', },
        { hid: 'og:url', name: 'og:url', content: this.$config.feUrl + '/info/kijk-gratis' },
        { hid: 'og:description', name: 'og:description', content: this.pages.infokijkgratis ? this.pages.infokijkgratis.seo.description : 'Secret Circle zendt 24 uur per dag op televisie uit. Onze tv-zender kan je bij de meeste landelijke providers terugvinden. In veel gevallen zit Secret Circle zelfs in het basispakket. Er is dus een grote kans dat jij de hele dag door naar ons kan kijken zonder extra kosten.' },
        { hid: 'description', name: 'description', content: this.pages.infokijkgratis ? this.pages.infokijkgratis.seo.description : 'Secret Circle zendt 24 uur per dag op televisie uit. Onze tv-zender kan je bij de meeste landelijke providers terugvinden. In veel gevallen zit Secret Circle zelfs in het basispakket. Er is dus een grote kans dat jij de hele dag door naar ons kan kijken zonder extra kosten.' },
        { hid: 'keywords', name: 'keywords', content: this.pages.infokijkgratis ? this.pages.infokijkgratis.seo.keywords : 'gratis, seksfilms, gratis seksfilms, kijk 24/7'},
        ]
    }
  },
}
